import React, { FC } from 'react';
import { Tooltip, TooltipProps } from 'recharts';
import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';

import BarLineGraphTooltip from '../BarLineGraphTooltip';

// Small hack to allow having two different tooltips on a composed chart
// This is not perfect since they essentially are a single tooltip that changes behaviour
export const MultiTooltip: FC<TooltipProps<ValueType, NameType>> = ({
  payload,
  ...rest
}) => {
  if (!payload) {
    return null;
  }

  const monthStartBalancePayload = payload?.find(
    (p) => p.dataKey === 'monthStartBalance',
  );
  if (monthStartBalancePayload?.payload?.monthStartBalance !== null) {
    return (
      <Tooltip
        content={<BarLineGraphTooltip />}
        isAnimationActive={false}
        payload={payload}
        position={{ y: -50 }}
        {...rest}
      />
    );
  }

  return (
    <Tooltip content={<BarLineGraphTooltip />} payload={payload} {...rest} />
  );
};

// hack to make recharts think this is a valid tooltip
// @see: https://github.com/recharts/recharts/blob/master/src/chart/generateCategoricalChart.tsx#L1966C36-L1966C36
// @see: https://github.com/recharts/recharts/blob/master/src/util/ReactUtils.ts#L121C40-L121C40
MultiTooltip.displayName = 'Tooltip';
